export class ClientAdded {
  static eventName = 'client.added';
}

export class ClientEdited {
  static eventName = 'client.edited';

  id: string;

  name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }
}

export class ClientSetup {
  static eventName = 'client.setup';
}

export class PricePlanStarted {
  static eventName = 'price_plan.started';
}

export class EmailReportGenerated {
  static eventName = 'email_report.generated';
}

export class EmailCampaignsFetched {
  static eventName = 'email_campaigns.fetched';
}
